import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { MeResponse } from '@/shared/types/auth'

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: MeResponse | null
  setTokens: (access: string, refresh: string) => void
  setUser: (user: MeResponse) => void
  clearAuth: () => void
  hasPermission: (perm: string) => boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      user: null,

      setTokens: (access, refresh) =>
        set({ accessToken: access, refreshToken: refresh }),

      setUser: (user) => set({ user }),

      clearAuth: () =>
        set({ accessToken: null, refreshToken: null, user: null }),

      hasPermission: (perm) => {
        const { user } = get()
        return user?.permissions?.includes(perm) ?? false
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
      }),
    },
  ),
)
